module.exports = __webpack_public_path__ + "static/media/appstore.9108e56b.svg";